import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { select, Store } from '@ngrx/store';
import { BaseAppState } from '../../../core/store/reducers';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AUTH_UI_PATHS } from '../definitions/auth-ui-navigation.definitions';
import { AuthSelectors } from '../selectors/auth.selectors';

@Injectable()
export class AdminGuard implements CanActivate {
  isAdmin$ = this.store.pipe(select(AuthSelectors.getIsAdmin));

  constructor(private router: Router, private store: Store<BaseAppState>) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.isAdmin$.pipe(
      take(1),
      map((isAdmin) => {
        if (!isAdmin) {
          const redirectUrlTree = this.router.createUrlTree([AUTH_UI_PATHS.root.login]);
          return redirectUrlTree;
        }
        return true;
      })
    );
  }
}
